var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"div",staticClass:"ys-float-btn",style:({
    width: _vm.itemWidth + 'px',
    height: _vm.itemHeight + 'px',
    left: _vm.left + 'px',
    top: _vm.top + 'px'
  }),on:{"click":_vm.onBtnClick}},[_vm._t("icon"),_c('p',[_vm._v(_vm._s(_vm.text))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }